import {
	AppPage,
	MimaInput,
	MimaText,
	MimaTextArea,
	ReceiptCheckBox as RCB,
	MimaButton,
	PageLoader,
	MimaDropdown,
} from '../../components';
import {
	amountFormatter,
	currencies,
	chargeSplitValues,
} from '../../utils/utils';
import constant from '../../utils/constant';
import styles from '../../assets/styles/Booking/Booking.module.scss';
import { businessStore, bookingStore, userStore } from '../../stores';
import { DeleteBookingContainer } from '../../containers';
import MimaOptionMenu from '../../components/OptionMenu';
import { AnimatePresence } from 'framer-motion';
import { Formik } from 'formik';
import moment from 'moment';
import React from 'react';
import Survey from '../../components/Survey/Survey';
import CreateBookingContainer from '../../containers/BookingContainer/CreateBookingContainer';
import { EditBookingContainer } from '../../containers/BookingContainer';

const Booking = ({
	viewBookings,
	viewLinks,
	createLinks,
	bookingNav,
	validationSchema,
	loading,
	editLink,
	refresh,
	handleOptionSelect,
	closeModal,
	deleteLink,
	cancelEdit,
	goToCreateLinks,
	showSurvey,
	setShowSurvey,
	setEditLink,
	setViewBookings,
	setViewLinks,
	setCreateLinks,
}) => {
	const bookings = bookingStore.allBookings;
	const bookingLinks = bookingStore.allBookingLinks;

	const business = businessStore.business;
	const selectedLink = bookingStore.selectedBookingLink;

	return (
		<AppPage pageTitle="Bookings" refresh={refresh}>
			<div className={styles.main}>
				<div className={styles.main_nav}>
					{bookingNav.map((navItem, index) => (
						<div
							key={index}
							onClick={navItem.clickAction}
							className={
								navItem.activeState
									? styles.main_nav_item_active
									: styles.main_nav_item
							}>
							{navItem.title}
						</div>
					))}
				</div>

				<div className={styles.main__content}>
					{viewBookings && (
						<>
							{loading ? (
								<PageLoader title="while we load your bookings" />
							) : (
								<div>
									{bookings && bookings.length === 0 ? (
										<div className={styles.main__center}>
											<MimaText
												mb={2}
												variant="subtitle"
												align="center"
												color="var(--color-primary)">
												You are yet to have a booking.
											</MimaText>
										</div>
									) : (
										<>
											<MimaText variant="subtitleBold" mb={2} align="center">
												Available Bookings
											</MimaText>
											<div className="whiteTable">
												<table>
													<thead>
														<tr>
															<th>Created Date </th>
															<th> Title</th>
															<th> Customer </th>
															<th> Session DateTime </th>
															<th> Amount </th>
															<th> Note </th>
															<th> status </th>
														</tr>
													</thead>
													<tbody>
														{bookings?.length > 0 &&
															bookings.map((booking, index) => (
																<tr key={index}>
																	<td>
																		{moment(booking?.createdAt).format(
																			'DD-MM-YYYY hh:mm'
																		)}{' '}
																	</td>
																	<td>{booking?.bookingLink?.title}</td>
																	<td>{booking?.customer?.fullname}</td>
																	<td>
																		{moment(booking?.sessionDateTime).format(
																			'DD-MM-YYYY hh:mm'
																		)}{' '}
																	</td>
																	<td>
																		{amountFormatter(
																			booking?.currencyCode
																		).format(booking?.amount)}
																	</td>
																	<td>{booking?.note}</td>
																	<td
																		className={
																			booking?.status !== 'UNPAID'
																				? styles.active
																				: styles.deactivated
																		}>
																		{booking?.status}
																	</td>
																</tr>
															))}
													</tbody>
												</table>
											</div>
										</>
									)}
								</div>
							)}
						</>
					)}
					{viewLinks && (
						<>
							{loading ? (
								<PageLoader title="while we load your links" />
							) : (
								<div>
									{bookingLinks && bookingLinks.length === 0 ? (
										<div className={styles.main__center}>
											<MimaText
												mb={2}
												variant="subtitle"
												align="center"
												color="var(--color-primary)">
												You are yet to create a booking Link.
											</MimaText>
											<MimaButton
												title="Create Link"
												onClick={goToCreateLinks}
												loading={loading}
												variant="filter"
												mb={2}
												width={18}
											/>
										</div>
									) : (
										<>
											<MimaText variant="subtitleBold" mb={2} align="center">
												Available Booking Links
											</MimaText>
											<div className="whiteTable">
												<table>
													<thead>
														<tr>
															<th>Created Date </th>
															<th> Link Name</th>
															<th>Description</th>
															<th> Amount </th>
															<th> Link Address </th>
															<th> Status </th>
															<th>Actions</th>
														</tr>
													</thead>
													<tbody>
														{bookingLinks &&
															bookingLinks.map((link, index) => (
																<tr key={index}>
																	<td>
																		{moment(link.createdAt).format(
																			'DD-MM-YYYY hh:mm'
																		)}{' '}
																	</td>
																	<td>{link.title}</td>
																	<td>{link.description}</td>
																	<td>
																		{amountFormatter(link.currencyCode).format(
																			link.amount
																		)}
																	</td>
																	<td>{link.bookingUrl}</td>
																	<td
																		className={
																			link.status === 'ACTIVE'
																				? styles.active
																				: styles.deactivated
																		}>
																		{link.status}
																	</td>

																	<td>
																		{link.status === 'ACTIVE' ? (
																			<MimaOptionMenu
																				options={[
																					{
																						value: 'Edit Link',
																						label: 'Edit Link',
																					},
																					{
																						value: 'Deactivate Link',
																						label: 'Deactivate Link',
																					},
																					{
																						value: 'Copy Link Url',
																						label: 'Copy Link Url',
																					},
																				]}
																				onOptionSelected={option => {
																					handleOptionSelect(
																						link._id,
																						link,
																						option
																					);
																				}}
																			/>
																		) : (
																			''
																		)}
																	</td>
																</tr>
															))}
													</tbody>
												</table>
											</div>
										</>
									)}
								</div>
							)}
						</>
					)}

					{createLinks && (
						<CreateBookingContainer
							setShowSurvey={setShowSurvey}
							closeModal={closeModal}
							validationSchema={validationSchema}
							// onSubmit={onSubmit}
							selectedLink={selectedLink}
							setEditLink={setEditLink}
							setViewBookings={setViewBookings}
							setViewLinks={setViewLinks}
							setCreateLinks={setCreateLinks}
							createLinks={createLinks}
						/>
					)}
					{editLink && (
						<EditBookingContainer
							setShowSurvey={setShowSurvey}
							closeModal={closeModal}
							validationSchema={validationSchema}
							// onSubmit={onSubmit}
							editLink={editLink}
							cancelEdit={cancelEdit}
							selectedLink={selectedLink}
							setEditLink={setEditLink}
							setViewBookings={setViewBookings}
							setViewLinks={setViewLinks}
							setCreateLinks={setCreateLinks}
						/>
					)}
				</div>
			</div>

			{(deleteLink || showSurvey) && (
				<div className="modal">
					<AnimatePresence>
						{deleteLink && <DeleteBookingContainer closeModal={closeModal} />}
						{showSurvey && (
							<Survey
								title=""
								reviewId={userStore.reviewId}
								closeModal={() => {
									setShowSurvey(false);
								}}
							/>
						)}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default Booking;
